import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { TRADER_IMPERSONATION_TOKEN_KEY } from '../lib/api';
import { cabinetPath, cabinetUrl } from '../lib/domains';

export const TraderImpersonatePage: React.FC = () => {
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const token = searchParams.get('token');

        if (token) {
            sessionStorage.setItem(TRADER_IMPERSONATION_TOKEN_KEY, token);
            window.location.replace(cabinetPath('trader', '/dashboard'));
            return;
        }

        window.location.replace(cabinetUrl('admin', '/dashboard'));
    }, [searchParams]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-900">
            <div className="text-center text-slate-600 dark:text-slate-300">
                <Loader2 className="h-8 w-8 animate-spin mx-auto mb-3" />
                <p>Открываем дашборд трейдера...</p>
            </div>
        </div>
    );
};
